<template>
    <div>
        <template v-if="field.type == 'models'">
            <div>
                {{ field.text }}
                <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on:click="addItem(field.initial, localEditedItem[field.value])"
                >
                    Agregar
                </v-btn>
                <div v-for="(model, index) in existingItems" :key="index">
                    <models-universidades-field
                        v-for="modelsField in field.inputs"
                        :key="modelsField.value"
                        :field="modelsField"
                        :localEditedItem="model"
                        :afterDialogOpen="afterDialogOpen"
                    ></models-universidades-field>
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-on:click="removeItem(index, localEditedItem[field.value])"
                    >
                        Borrar
                    </v-btn>
                </div>
            </div>
        </template>
        <template v-if="field.type == 'model'">
            <div>
                {{ field.text }}
                <models-universidades-field
                    v-for="modelsField in field.inputs"
                    :key="modelsField.value"
                    :field="modelsField"
                    :localEditedItem="localEditedItem[field.value]"
                    :afterDialogOpen="afterDialogOpen"
                ></models-universidades-field>
            </div>
        </template>
        <template v-if="field.type == 'file'">
            <v-file-input
                :label="field.text"
                @change="onFileChange($event, field.value, localEditedItem, field)"
            ></v-file-input>

            <div class="text-center" v-if="field.uploading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>

            <v-img
                v-if="!field.uploading && localEditedItem[field.value]"
                contain
                :src="localEditedItem[field.value]"
            ></v-img>

            <v-dialog v-if="field.errorDialog" v-model="field.errorDialogOpen" width="500">
                <v-card>
                    <v-card-title class="headline grey lighten-2">
                        {{ field.errorDialogTitle }}
                    </v-card-title>
                    <v-card-text>
                        {{ field.errorDialogText }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="field.errorDialogOpen = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <template v-else-if="afterDialogOpen && field.type == 'ckeditor'">
            <div class="mb-2">
                {{ field.text }}
                <ckeditor :editor="editor" v-model="localEditedItem[field.value]" :config="editorConfig"></ckeditor>
            </div>
        </template>

        <v-text-field
            v-else-if="!field.type || field.type == 'text'"
            v-model="localEditedItem[field.value]"
            :label="field.text"
        ></v-text-field>
    </div>
</template>

<script>
import { UploadsService } from "../../../services/carreras-api.service"
import { UploadAdapterPlugin } from "@/utils/upload-adapter-plugin"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

export default {
    props: ["field", "localEditedItem", "afterDialogOpen"],
    data: () => ({
        editor: ClassicEditor,
        editorConfig: {
            extraPlugins: [UploadAdapterPlugin],
            mediaEmbed: {
                previewsInData: true
            }
        }
    }),
    methods: {
        onFileChange: (file, key, item, field) => {
            if (!file) {
                item[key] = undefined

                return
            }

            field.uploading = true

            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.onload = () => {
                UploadsService.create({
                    file: reader.result.replace(/^data:.+;base64,/, ""),
                    name: file.name,
                    prefix: "universidades/anuncios"
                }).then(res => {
                    if (res.success) {
                        item[key] = res.pathToFile
                    } else {
                        field.errorDialogOpen = true
                    }

                    field.uploading = false
                })
            }
        },
        addItem(initial, array) {
            const cloned = JSON.parse(JSON.stringify(initial))
            array.push(cloned)
        },
        removeItem(index, array) {
            if (array[index].id) {
                array.splice(index, 1, {
                    ...array[index],
                    _destroy: true
                })
            } else {
                array.splice(index, 1)
            }
        }
    },
    computed: {
        existingItems() {
            return this.localEditedItem[this.field.value].filter(item => !item._destroy)
        }
    }
}
</script>
